import PropTypes from 'prop-types';
/** @jsx jsx needed to get Storybook to render */
import { css, jsx } from '@emotion/core';
import Link from '../../atoms/Link/Link';
import {
  breakpoints,
  colors,
  fontSizes,
  fontWeights,
  unitConverter as uc,
  arrowSymbol,
} from '../../../styles/base';
import { Heading5 } from '../../atoms/Headings/Headings';
import Card from '../../atoms/Card/Card';
import sanityImage from '../../../utils/sanityImage';
import Image from '../../atoms/Image/Image';
import { truncateText } from '../../../utils/textUtils';

const cardCss = css`
  width: ${uc('284px')};
  height: ${uc('300px')};
  margin: ${uc('0px 14px 20px 0px')};
  overflow: hidden;
  border-radius: ${uc('30px')};
  cursor: pointer;

  @media (${breakpoints.mobile}) {
    width: 100%;
  }
`;

const contentContainerCss = css`
  width: 100%;
  height: 100%;
  padding: ${uc('20px')};
  background-color: ${colors.white};
`;

const spanCss = css`
  color: ${colors.accent};
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.fifteen};
  text-transform: uppercase;
`;

const headingCss = css`
  margin-top: ${uc('10px')};
  color: ${colors.primary};
  font-weight: ${fontWeights.semiBold};
  line-height: ${uc('24px')};

  &:hover {
    &::after {
      content: ${arrowSymbol};
      margin-left: ${uc('3px')};
    }
  }
`;

const imageCss = css`
  width: auto;
  max-height: ${uc('120px')};
`;

const imageWrapperCss = css`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${uc('120px')};
  padding: ${uc('20px')};
  background-color: ${colors.white};
  border-bottom: ${uc('1px')} solid ${colors.lightGray.one};
`;

const NewsCoverageTile = ({ image, link, subtitle, title }) => {
  return (
    <Link to={link}>
      <Card css={cardCss}>
        <div css={imageWrapperCss}>
          {image && image.asset ? (
            <Image
              css={imageCss}
              src={sanityImage(image)
                .auto('format')
                .maxHeight(120)
                .url()}
            />
          ) : null}
        </div>
        <div css={contentContainerCss}>
          <span css={spanCss}>{subtitle}</span>
          <Heading5 css={headingCss}>{truncateText(title, 80)}</Heading5>
        </div>
      </Card>
    </Link>
  );
};

NewsCoverageTile.propTypes = {
  image: PropTypes.instanceOf(Object).isRequired,
  link: PropTypes.oneOfType([
    PropTypes.instanceOf(Object).isRequired,
    PropTypes.string.isRequired,
  ]).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default NewsCoverageTile;
